import { render, staticRenderFns } from "./GithubAccountModal.vue?vue&type=template&id=2243d611&"
import script from "./GithubAccountModal.vue?vue&type=script&lang=js&"
export * from "./GithubAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GithubAccountModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GithubAccountModal.vue
// module id = 2359
// module chunks = 1